import React from 'react';

const Loadable = React.lazy(() => import('../../pages/Apps/Apps'));

export default Loadable;
